import { useTradeModule } from '../TradeModuleCtx';

export const useOpenPositionFee = () => {
  const ctx = useTradeModule();
  
return ctx.openPositionFee;
};